import { render, staticRenderFns } from "./Hotelinfo.vue?vue&type=template&id=d3059a2c"
import script from "./Hotelinfo.vue?vue&type=script&setup=true&lang=js"
export * from "./Hotelinfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Hotelinfo.vue?vue&type=style&index=0&id=d3059a2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports